export enum MessageNamespaces {
  LOCAL_NOTIFICATION = 'local-notification',
}
